<div class="k-overlay" *ngIf="documentViewerDialogOpened"></div>
<kendo-window *ngIf="documentViewerDialogOpened" class="kendo-window" [top]="60" [width]="950" [height]="700"
    style="min-height: 200px;" (close)="closeDialog()" [state]="windowState">

    <kendo-window-titlebar>
        <div class="k-window-title">
            <h3 class="ellipsis-text" style="color:#fff;">
                {{ (model.description !== '' ? model.description : model.name ) }}
                {{model.createdOn | date:'medium' }}
            </h3>
        </div>
        <button kendoWindowMaximizeAction></button>
        <button kendoWindowRestoreAction></button>
        <button kendoWindowCloseAction></button>
    </kendo-window-titlebar>

    <!--loading-->
    <div *ngIf="loadingDocument">
        <div class="container" style="margin: 0;position: absolute;top: 50%;left:0;transform: translate(0, -50%)">
            <div class="row justify-content-center">
                <span class="k-icon k-i-loading kendo-loading-icon"></span>
            </div>
        </div>
    </div>

    <button *ngIf="isSaveVisible() && !loadingDocument" appPreventClick class="k-button k-primary"
        style="position: absolute;right: 15px;top: 22px;z-index: 100" (click)="onSave($event)">{{'SAVE' | translate }}
    </button>

    <!--Show document based on type-->
    <div *ngIf="!loadingDocument">
        <div *ngIf="isSupportedDocumentType">
            <div *ngIf="isImage">
                <div class="text-center">
                    <kendo-slider [tickPlacement]="'none'" [min]="10" [max]="200" [smallStep]="1" [showButtons]="false"
                        class="w-100 ml-5 mr-5" [(ngModel)]="zoomImage" style="max-width:400px">
                    </kendo-slider>
                </div>
                <img [ngStyle]="{'width': zoomImage + '%'}" alt="{{'DOCUMENT' | translate}}" [src]="model.image"
                    *ngIf="model.image" />
            </div>
            <div *ngIf="isPdf">
                <kendo-pdfviewer style="width:100%;height:100vh;" [data]="model.content" [tools]="pdfViewerTools">
                </kendo-pdfviewer>
            </div>
            <div *ngIf="isXml">
                <pre *ngIf="!model.isCDA">{{model.content | xml}}</pre>
                <div *ngIf="model.isCDA" [innerHTML]="model.content"></div>
            </div>
            <div *ngIf="!isPdf && !isImage && !isXml">
                <p innerHTML="{{model.content}}"></p>
            </div>
        </div>
        <div *ngIf="!isSupportedDocumentType">
            <div class="text-center mt-5" translate [translateParams]="{value: model.mediaType}">
                {{'UNSUPPORTED-DOCUMENT-TYPE'}}
            </div>
        </div>
    </div>
</kendo-window>

<!--Save confirmation dialog-->
<kendo-dialog *ngIf="saveDialogOpened" title="{{'PLEASE-CONFIRM' | translate}}" [width]="400"
    (close)="saveDialogOpened = false">
    <p>{{'CONFIRM-SAVE-DOCUMENT' | translate}}</p>
    <span class="k-font-weight-bold">{{selectedDocumentName}}</span>
    <kendo-dialog-actions>
        <button kendoButton (click)="saveDialogOpened = false">{{'NO' | translate}}</button>
        <button appPreventClick kendoButton (click)="saveDocumentReference()">{{'YES' | translate}}</button>
    </kendo-dialog-actions>
</kendo-dialog>